module.exports = __webpack_public_path__ + "static/media/ke.f50e23ed.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/flags/ke.svg
// module id = 160
// module chunks = 0